export default (init, mode) => {
  const panelTitle = $(".footer-accordion__title");
  const visibilityMode = mode || "single";
  const isInitialized = init || "init";
  const transitionTime = 170;

  if (isInitialized === "init") {
    function hidePanels() {
      const activeTitles = panelTitle.filter(function() {
        return $(this).attr("aria-selected") === "true";
      });

      $.each(activeTitles, function() {
        $(this).attr("aria-selected", "false");
        $(this)
          .next()
          .slideUp(transitionTime);
      });
    }

    $.each(panelTitle, function() {
      const isOpen = $(this).attr("aria-selected");

      if (isOpen === "true") {
        $(this)
          .next()
          .slideDown(transitionTime);
      } else {
        $(this)
          .next()
          .slideUp(transitionTime);
      }
    });

    if (visibilityMode === "single") {
      panelTitle.on("click", function() {
        const title = $(this);
        const panel = $(this).next();

        if (panel.length) {
          if (panel.is(":visible")) {
            $.each(panelTitle, function() {
              hidePanels();
            });
          } else {
            hidePanels();
            title.attr("aria-selected", "true");
            panel.slideDown(transitionTime);
          }
        }
      });
    } else if (visibilityMode === "multiply") {
      panelTitle.on("click", function() {
        const panel = $(this).next();

        if (panel.length) {
          panel.slideDown(transitionTime);
        } else {
          panel.slideUp(transitionTime);
        }
      });
    }
  } else {
    $(panelTitle).unbind("click");
  }

  const languageHandlerInit = () => {
    const languageSwitcher = $(".js-language-switcher");
    const languageWrapper = $(".language-dropdown");
    const languageLabel = $(".language-dropdown__label");

    languageLabel.on("click", function(e) {
      if (e.target !== this) return;

      $(this).toggleClass("is-active");
      languageWrapper.toggleClass("is-open");
    });

    languageSwitcher.on("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      languageLabel.text($(this).text());
      languageWrapper.removeClass("is-open");

      const token = $("meta[name='csrf-token']").attr("content");
      const localeValue = $(this).attr("locale");

      $.ajax({
        url: `/locale/change`,
        type: "POST",
        data: {
          locale: localeValue
        },
        dataType: "json",
        headers: { "X-CSRF-TOKEN": token },
        success: function() {
          window.location.reload();
        }
      });
    });
  };

  languageHandlerInit();
};
